import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CompliancePredesResdesDespatchesReport from '../components/CompliancePredesResdesDespatchesReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CompliancePredesResdesDespatchesSummarySelectors';

export function CompliancePredesResdesDespatchesSummaryContainer(props) {
  return (
    <CompliancePredesResdesDespatchesReport
      reportId={ReportDefinitions.PREDES_RESDES_DESPATCHES_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

CompliancePredesResdesDespatchesSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CompliancePredesResdesDespatchesSummaryContainer);
